import { useContext } from 'react';
import { LicenceModelBillingType, SiteFeature } from '../apiRtk/be4feApi';
import { ISiteContextData, SiteContext } from './SiteContext';

export function useSiteContext() {
  const siteContext = useContext(SiteContext);

  if (siteContext === undefined) {
    return {
      apartmentStatesCounts: {},
      hasSiteBillingType: (_billingType: LicenceModelBillingType) => false,
      isSiteFeatureEnabled: (_feature: SiteFeature) => false,
    };
  }

  return {
    apartmentStatesCounts: siteContext.apartmentStatesCounts ?? {},
    hasSiteBillingType: (billingType: LicenceModelBillingType) => hasSiteBillingType(siteContext, billingType),
    isSiteFeatureEnabled: (feature: SiteFeature) => isSiteFeatureEnabled(siteContext, feature),
  };
}

function isSiteFeatureEnabled(context: ISiteContextData, feature: SiteFeature) {
  return context.siteFeatures?.includes(feature) ?? false;
}

function hasSiteBillingType(context: ISiteContextData, billingType: LicenceModelBillingType) {
  return context.billingType === billingType;
}
